"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSpaces = void 0;
var _fpoSquare = _interopRequireDefault(require("../images/fpo-square.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const removeSpaces = url => {
  if (!url) {
    return _fpoSquare.default;
  } else {
    return url.replace(/\s/g, "%20");
  }
};
exports.removeSpaces = removeSpaces;